/*
 * Get Surgeons GraphQL specification
 * @module src/graphql/getSurgeons
 */
/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const GET_SURGEONS = gql`
  query getSurgeons($accountId: String, $salesRepId: String, $filters: SurgeonFilters) {
    getSurgeons(accountId: $accountId, salesRepId: $salesRepId, filters: $filters) {
      id
      value
      hospitalId
      surgeonERPCode
      surgeonId
      surgeonName
      contactId
      contactName
      isContact
      __typename
    }
  }
`;
